<script lang="ts">
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import type {DirectoryNode} from 'src/typings';
    import type {MvMoveFileModalModel} from 'src/features/media-viewer/lib/mv-types';
    import {createPayloadActionResponse} from 'src/modals/modal-utils';
    import {exists} from 'shared/utils/custom-utils';
    import KpModalHeaderCloseButton from 'src/modals/kp-modal/KpModalHeaderCloseButton.svelte';
    import KpModalContent from 'src/modals/kp-modal/KpModalContent.svelte';
    import KpModalTitle from 'src/modals/kp-modal/KpModalTitle.svelte';
    import Loc from 'shared/components/kp-markdown/Loc.svelte';
    import KpModalFooterCloseButton from 'src/modals/kp-modal/KpModalFooterCloseButton.svelte';
    import OverviewDirectoryTree from './OverviewDirectoryTree.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    export let model: MvMoveFileModalModel;
    export let modalWindowActions: ModalWindowActions;

    let selectedDirectory: DirectoryNode | null = null;

    const handleDirectorySelect = (event: CustomEvent<DirectoryNode | null>) => {
        selectedDirectory = event.detail;
    }

    const handleSubmit = () => {
        modalWindowActions.resolve(Promise.resolve(createPayloadActionResponse(selectedDirectory)));
    }
</script>

<KpModalContent {modalWindowActions} additionalClasses="sutor-references-date-selection-modal">
    <svelte:fragment slot="header">
        <KpModalTitle>
            <Loc code="mediaviewer.fileExplorer.MoveFilesModalTitle"/>
        </KpModalTitle>

        <KpModalHeaderCloseButton/>
    </svelte:fragment>

    <svelte:fragment slot="body">
        <OverviewDirectoryTree
                rootDirectory={model.rootDirectory}
                {selectedDirectory}
                on:directory-select={handleDirectorySelect}/>
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpModalFooterCloseButton/>

        <KpButton isDisabled={!exists(selectedDirectory)}
                  buttonStyle="success"
                  on:click={handleSubmit}>

            <Loc code="mediaviewer.fileExplorer.MoveFilesModalSubmitButton"/>
        </KpButton>
    </svelte:fragment>
</KpModalContent>